import { State, Action, MetricsType, MetricsUnit } from "./types";

export function reducer(state: State, action: Action): State {
  const actionType = action.type;

  switch (action.type) {
    case "LOAD_METRICS":
      return {
        ...state,
        metricsLoading: true,
      };
    case "SET_TIME_FRAME":
      return {
        ...state,
        timeFrameOption: action.timeFrameOption,
        startDate: action.startDate,
        endDate: action.endDate,
        metricsLoaded: {
          [MetricsType.Electricity]: false,
          [MetricsType.Gas]: false,
          [MetricsType.Water]: false,
        },
      };
    case "SET_SELECTED_SITES":
      return {
        ...state,
        selectedSites: action.selectedSites,
        metricsLoaded: {
          [MetricsType.Electricity]: false,
          [MetricsType.Gas]: false,
          [MetricsType.Water]: false,
        },
      };
    case "SET_METRICS_TYPE":
      return {
        ...state,
        metricsType: action.metricsType,
        metricsUnit: MetricsUnit[action.metricsType],
      };
    case "SET_RANKED_SITES_SORTING_DIRECTION":
      return {
        ...state,
        sortingDirection: {
          ...state["sortingDirection"],
          rankedSites: action.rankedSites,
        },
      };
    case "SET_RANKED_YEARS_SORTING_DIRECTION":
      return {
        ...state,
        sortingDirection: {
          ...state["sortingDirection"],
          rankedYears: action.rankedYears,
        },
      };
    case "METRICS_REQUEST_SUCCESS":
      const newState = {
        ...state,
        metricsLoading: false,
        metricsLoadingError: false,
        metricsLoaded: {
          ...state.metricsLoaded,
          [action.metricsType]: true,
        },
        metricsType: action.metricsType,
        metricsUnit: action.metricsUnit,
        metrics: {
          ...state.metrics,
          ...action.metrics,
        },
      };
      // If the response is empty, the existing metrics data for current action must be cleared
      if (Object.keys(action.metrics).length === 0) {
        delete newState.metrics[action.metricsType];
      }

      return newState;
    case "METRICS_REQUEST_FAIL":
      return {
        ...state,
        metricsLoading: false,
        metricsLoadingError: true,
        metricsLoaded: {
          ...state.metricsLoaded,
          [state.metricsType]: false,
        },
      };
    default:
      throw new Error(`Unhandled action type: ${actionType}`);
  }
}
